import { useContext } from 'react'

import SearchOrPOISummaryCard from '../SummaryCards/Search/SearchOrPOISummaryCard'
import type { ExploreItemMapMarker } from '../utils'

import { TripMapContext } from 'tripPlanner/contexts/TripMapContext'

interface Props {
  selectedMarker: ExploreItemMapMarker | undefined
  onSave: () => void
}

function SearchCardSingle({
  selectedMarker,
  onSave,
}: Props) {
  const { onDeselectMapItem } = useContext(TripMapContext)

  if (selectedMarker) {
    return (
      <SearchOrPOISummaryCard
        item={selectedMarker.item}
        showCloseButton
        onClose={onDeselectMapItem}
        onSave={onSave}
      />
    )
  }
  return null
}

export default SearchCardSingle
